<template>
  <div class="container">
    <filter-wrapper
      :filter-item="{
        searchBox: true,
        canteen: true,
        eatery: true,
        machine: true
      }"
    ></filter-wrapper>
    <div class="btn-wrapper-1 header">
      <el-button type="primary" size="mini" @click="setModelList"
        >查询</el-button
      >
      <el-button @click="toggleModal" size="mini" type="primary"
        >添加碗碟</el-button>
      &nbsp;&nbsp;
      <el-badge class="mark" :value="modelList.length || 0">
        <el-tag type="success" size="mini">总数</el-tag>
      </el-badge>
      <!--<el-button v-if="collectBtnShow" @click="imageCollect" type="primary"-->
      <!--&gt;模拟图片采集</el-button>-->
    </div>
    <el-row :gutter="10" class="card-wrapper" v-if="modelList.length > 0">
      <el-col :span="3" v-for="_class in modelList" :key="_class.class_id">
        <el-card
          class="box-card"
          :body-style="{ height: '100px', 'text-align': 'center' }"
        >
          <div slot="header" class="clearfix">
            <span>{{ _class.dish_name ? _class.dish_name : `暂无` }}</span>
            <el-button
              style="float: right; padding: 3px 2px"
              class="danger-text"
              type="text"
              icon="el-icon-delete"
              @click="deleteRalateClass(_class.class_id)"
            ></el-button>
            <el-button
              style="float: right; padding: 3px 2px"
              type="text"
              icon="el-icon-edit"
              @click="editRelateClass(_class)"
            ></el-button>
          </div>
          <!--<div class="image-warpper">-->
          <!--<img-->
          <!--class="image-item"-->
          <!--:src="_class.dish_image_url"-->
          <!--alt=""-->
          <!--/>-->
          <!--</div>-->
          <classDishWrapper
            class="class-dish-wrapper"
            :image="_class"
          ></classDishWrapper>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="10" class="no-dish" v-else>
     <!--<el-col :span="6"</el-col>-->
      此餐厅无碗碟!
    </el-row>
    <el-dialog title="提示" :visible.sync="addMarkImageShow" width="50%">
      <el-upload
        drag
        action
        :file-list="markImageList"
        multiple
        :http-request="handleIploadMarkImage"
        list-type="picture-card"
        :on-remove="deleteImage"
      >
        <el-button size="small" icon="el-icon-plus"></el-button>
        <div class="img-wrapper"></div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAddImage">取 消</el-button>
        <el-button type="primary" @click="batchAddImages">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      width="400"
      title="请添加碗碟"
      class="dialog"
      :visible.sync="modelAddDialogShow"
      :show-close="false"
    >
      <el-input v-model="searchText" placeholder="快速搜索"></el-input>
      <dishesTable :dishes="classListBySearchFilter" @cancelAddClass="cancelAddClass" @confirmAddClass="confirmAddClass"></dishesTable>
    </el-dialog>
    <el-dialog
      class="dialog-1"
      title="碗碟信息修改"
      :visible.sync="relateClassEditDialog"
      width="30%"
    >
      <el-form ref="form" :model="current_class_meta_info" label-width="50px">
        <el-form-item label="名称" prop="dish_name">
          <el-input
            v-model="current_class_meta_info.dish_name"
            placeholder="请填写碗碟名称"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="价格" prop="dish_price">
          <el-input
            v-model="current_class_meta_info.dish_price"
            placeholder="请填写碗碟价格"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper">
        <el-button type="danger" @click="cancelEditClass">取消</el-button>
        <el-button type="success" @click="confirmEditClass">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import pinyinMatch from 'pinyin-match';
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import aliOss from 'ali-oss';
import md5 from 'js-md5';
import dishesTable from './dishesTable';
// import virtualCollection from 'vue-virtual-collection';
import {apiBatchAddImages, apiDeleteRelatedClass, apiEditCanteenClass, apiEditClassDish, apiImageCollect} from '@/api';
import aliUpload from '@/lib/aliOSSUpload';
import {errorMessage, successMessage} from '@/lib/msg';
import filterWrapper from '_c/filterWrapper';
import classDishWrapper from '_c/classDishWrapper';

export default {
  name: "dishModelUpload",
  components: {
    dishesTable,
    filterWrapper,
    classDishWrapper,
  },
  data() {
    const checkPrice = (rule, value, callback) => {
      if (value < 0 || value > 999) {
        callback(new Error("价格必须在0~1000之间"));
      } else {
        callback();
      }
    };
    return {
      searchText: "",
      rules: {
        dish_name: [
          { required: true, message: "请输入碗碟名称", trigger: "blur" }
        ],
        dish_price: [
          { required: true, message: "请输入碗碟价格", trigger: "blur" },
          { type: "number", message: "价格必须为数字", trigger: "blur" },
          { validator: checkPrice, trigger: "blur" }
        ],
        dish_type: [
          { required: true, message: "请输入识别类型", trigger: "blur" }
        ]
      },
      relateClassEditDialog: false,
      markImageList: [],
      dish_typeOptions: [
        {
          type: "碗碟识别模式",
          index: "1"
        },
        {
          type: "内容识别模式",
          index: "2"
        }
      ],
      selectedRows: [], // 选中的模型
      dish_image_url: "",
      client: null,
      current_class_meta_info: {
        dish_type: "1",
        dish_price: 0,
        dish_name: "",
        dish_image_url: ""
      },
      formLabelWidth: "80px",
      modelAddDialogShow: false,
      canteenList: [],
      addMarkImageShow: false
    };
  },
  mounted() {
    this.setSubTitle("餐厅碗碟库");
    this.setAllClassList();
    this.setModelList();
  },
  computed: {
    ...mapGetters(["modelList", "allClassList"]),
    userinfo() {
      return this.$store.getters.userinfo();
    },
    ...mapState({
      eateryList(state) {
        return state.global.eateryList;
      },
      listQuery(state) {
        return state.filterWrapper.listQuery;
      }
    }),
    collectBtnShow() {
      console.log(process.env.NODE_ENV);
      return process.env.NODE_ENV === "development";
    },
    // allClassList去除modelList的部分
    classListUniq() {
      return this.$_.differenceBy(this.allClassList, this.modelList, "class_id");
    },
    classListBySearchFilter() {
      let searchText = this.searchText;
      let list = this.classListUniq;
      if (searchText !== "") {
        return list.filter(a => {
          let res = pinyinMatch.match(
            a.dish_desc + "," + a.dish_native_name,
            searchText
          );
          return res.length > 0;
          // return canteen['canteen_name'].indexOf(search) !== -1 || canteen['eatery_name'].indexOf(search) !== -1;
        });
      } else {
        return list;
      }
    }
  },
  filters: {},
  methods: {
    ...mapMutations(["emitLoading", "removeLoading", "setSubTitle"]),
    ...mapActions(["setModelList", "setAllClassList"]),
    cancelAddClass () {
      this.modelAddDialogShow = false
    },
    confirmAddClass () {
      this.modelAddDialogShow = false
      this.setModelList()
    },
    showButton(row) {
      return !!this.$_.find(this.selectedRows, a => a.class_id === row.class_id);
    },
    editRelateClass(row) {
      this.relateClassEditDialog = true;
      this.current_class_meta_info = this.$_.cloneDeep(row);
    },
    async confirmEditClass() {
      // todo 等待后端接口
      this.relateClassEditDialog = false;
      try {
        await apiEditCanteenClass({
          canteen_id: this.listQuery.canteen.canteen_id,
          class_id: this.current_class_meta_info.class_id,
          dish_name: this.current_class_meta_info.dish_name,
          dish_price: this.current_class_meta_info.dish_price
        });
        successMessage("修改成功");
        this.setModelList();
      } catch (e) {
        errorMessage("修改失败");
        console.log(e);
      }
    },
    cancelEditClass() {
      this.relateClassEditDialog = false;
      this.current_class_meta_info = {};
    },
    async deleteRalateClass(class_id) {
      this.$confirm("提示", "是否删除", {
        confirmButtonText: "确认删除",
        cancelButtonText: "取消"
      })
        .then(async () => {
          try {
            await apiDeleteRelatedClass({
              class_id,
              apiKey: this.userinfo.api_key,
              canteen_id: this.listQuery.canteen.canteen_id
            });
            this.setModelList();
            this.$message.warning("删除成功");
          } catch (e) {
            this.$message.error("删除失败" + e.message);
          }
        })
        .catch(() => {
          this.$message.error("已取消删除");
        });
    },
    scaleImage(row) {
      let imageUrl = row.image_url;
      console.log("sadsadsadsad");
    },
    checkForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.onConfirm();
        }
      });
    },
    cancelAddImage() {
      this.markImageList = [];
      this.addMarkImageShow = false;
    },
    deleteImage(file, fileList) {
      console.log(fileList);
      this.markImageList = fileList;
    },
    handleIploadMarkImage(option) {
      // this.markImageList.push(option.file)
      let file = option.file;
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      let md5key = "";
      let that = this;
      fileReader.onload = async e => {
        let md5key = md5(e.target.result);
        aliUpload(
          {
            bucket: "dish-model-test"
          },
          file
        )
          .then(res => {
            that.markImageList.push({
              url: res.url,
              md5: md5key
            });
          })
          .catch(e => {
            console.log(e);
          });
      };
    },
    batchAddImages() {
      let that = this;
      apiBatchAddImages({
        apiKey: this.userinfo.api_key,
        imgList: this.markImageList,
        canteenId: this.listQuery.canteen.canteen_id
      })
        .then(res => {
          if (res.state_code === 0) {
            this.addMarkImageShow = false;
            let result = {
              duplicated:
                res.duplicated && res.duplicated.length
                  ? res.duplicated.length
                  : 0
            };
            if (result.duplicated !== 0) {
              that.$message({
                message: `${result.duplicated}张图片与数据库重复, 未上传`,
                type: "error"
              });
            } else {
              that.$message({
                message: `上传成功`,
                type: "success"
              });
            }
            that.markImageList = [];
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    addMarkImage() {
      this.addMarkImageShow = true;
    },
    // todo:图片采集功能实际是在客户端中使用, 网页只用作测试跑通流程
    async imageCollect() {
      // this.emitLoading()
      this.$store.commit("emitLoading", {});
      let dataList = [
        {
          dish_region_url:
            "http://dish-model-test.oss-cn-shanghai.aliyuncs.com/js-label-img1542704852291.jpg",
          data_label_info: {
            dish_regions: [
              {
                h: 0.60000002384185791,
                w: 0.4375,
                x: 0.27250000834465027,
                y: 0.18000000715255737
              }
            ]
          }
        },
        {
          dish_region_url:
            "http://dish-model-test.oss-cn-shanghai.aliyuncs.com/js-label-img1542704852292.jpg",
          data_label_info: {
            dish_regions: [
              {
                h: 0.60000002384185791,
                w: 0.4375,
                x: 0.27250000834465027,
                y: 0.18000000715255737
              }
            ]
          }
        },
        {
          dish_region_url:
            "http://dish-model-test.oss-cn-shanghai.aliyuncs.com/js-label-img1542704852291.jpg",
          data_label_info: {
            dish_regions: [
              {
                h: 0.60000002384185791,
                w: 0.4375,
                x: 0.27250000834465027,
                y: 0.18000000715255737
              }
            ]
          }
        },
        {
          dish_region_url:
            "http://dish-model-test.oss-cn-shanghai.aliyuncs.com/js-label-img1542710038370.jpg",
          data_label_info: {
            dish_regions: [
              {
                h: 0.52999997138977051,
                w: 0.37000000476837158,
                x: 0.054999999701976776,
                y: 0.35666665434837341
              },
              {
                h: 0.72666668891906738,
                w: 0.50999999046325684,
                x: 0.40999999642372131,
                y: 0.063333332538604736
              }
            ]
          }
        }
      ];
      try {
        await apiImageCollect({
          dataList,
          apiKey: this.userinfo.api_key,
          canteenId: this.listQuery.canteen.canteen_id,
          machineId: this.listQuery.machine.machine_id
        });
        successMessage("上传成功");
      } catch (e) {
        errorMessage("上传失败");
      }
      this.removeLoading();
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows;
    },
    onCancel() {
      this.current_class_meta_info = { dish_type: "1", dish_price: 0 };
      this.dish_image_url = "";
      this.modelAddDialogShow = false;
    },
    // 编辑按钮click
    eidtMetaModel(row) {
      this.modelAddDialogShow = true;
      if (row) {
        let { dish_image_url, dish_name } = row;
        this.current_class_meta_info = row;
        this.dish_image_url = dish_image_url;
        if (!this.current_class_meta_info.dish_type) {
          this.current_class_meta_info.dish_type = "1";
        }
      } else {
        this.current_class_meta_info = { dish_type: "1" };
        this.dish_image_url = "";
      }
    },
    // 更新或者添加
    async onConfirm() {
      this.modelAddDialogShow = false;
      // TODO: 后端接口已完善
      this.$set(
        this.current_class_meta_info,
        "dish_image_url",
        this.dish_image_url
      );
      // class_id 不存在， 添加新的碗碟
      if (!this.current_class_meta_info.class_id) {
        try {
          // 添加dishModel
          await apiAddClassDish({
            apiKey: this.userinfo.api_key,
            class_meta_info: this.current_class_meta_info,
            canteen_id: this.listQuery.canteen.canteen_id
          });
          console.log("添加model成功");
          successMessage("添加成功");
          this.$store.dispatch("setModelList");
        } catch (e) {
          console.log("添加model成功");
          errorMessage("添加失败");
          this.$store.dispatch("setModelList");
        }
      } else {
        // 更新碗碟信息
        let dish_image_url = this.current_class_meta_info.dish_image_url;
        let dish_name = this.current_class_meta_info.dish_name;
        let dish_price = this.current_class_meta_info.dish_price;
        try {
          await apiEditClassDish({
            canteen_id: this.listQuery.canteen.canteen_id,
            class_id: this.current_class_meta_info.class_id,
            class_meta_info: {
              dish_image_url,
              dish_name,
              dish_price
            }
          });
          console.log("添加model成功");
          successMessage("修改成功");
          this.$store.dispatch("setModelList");
        } catch (e) {
          errorMessage("修改失败");
          this.$store.dispatch("setModelList");
        }
      }
    },
    toggleModal() {
      this.modelAddDialogShow = true;
    },
    handleImageUpload(options) {
      let that = this;
      let file = options.file;
      let fileType = file.name.split(".")[1];
      let storeAs = new Date().getTime() + "." + fileType;
      this.createOssClient();
      this.client.put(storeAs, file).then(res => {
        that.dish_image_url = res.url;
      });
    },
    createOssClient() {
      let options = {
        region: "oss-cn-shanghai",
        accessKeyId: "LTAI8UIymyrGyBJo",
        accessKeySecret: "TgUaBCFsjkoJqHMDk3iqcVebdW4y5z",
        bucket: "zhiyan-dish-model"
      };
      this.client = new aliOss(options);
    }
  }, // end canods
  watch: {
    // modelAddDialogShow() {
    //   if (this.modelAddDialogShow === false) {
    //     this.$refs["form"].resetFields();
    //     this.current_class_meta_info = { dish_type: "1", dish_price: 0 };
    //     this.dish_image_url = "";
    //     // this.$store.dispatch('setModelList')
    //   }
    // },
    listQuery: {
      handler() {
        this.setModelList();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  .btn-wrapper-1 {
    top: -35px;
  }
  .dialog {
    .btn-wrapper {
      position: absolute;
      top: 0;
      right: 50px;
      padding: 10px;
    }
  }
  .dialog-1 {
    .btn-wrapper {
      text-align: right;
    }
  }
  .class-dish-wrapper {
    display: inline-block;
    width: 100px;
    height: 100px;
  }
  .class-dish-wrapper-1 {
    width: 50px;
    height: 50px;
  }
  .class-dish-wrapper-2 {
    text-align: center;
    width: 50px;
    height: 50px;
    display: inline-block;
    padding-right: 5px;
  }
}
</style>
